import { useState } from "react";

export default function Navbar({ menuItems = [] }) {
  const [open, setOpen] = useState(false);

  return (
    <header className="topbar">
      <div className="logo">
        <div className="logo-icon">
          <b>10</b>
          <b>27</b>
        </div>
        <div className="logo-text">
          <i>24/7</i>
          <span>ROULETTE</span>
        </div>
      </div>
      <button
        className="menu-btn"
        aria-label="Menu"
        onClick={() => setOpen((o) => !o)}
      >
        <span />
        <span />
        <span />
      </button>
      <nav className="menu" hidden={!open}>
        {menuItems.map((m) => (
          <button
            key={m.label}
            onClick={() => {
              m.onClick();
              setOpen(false);
            }}
          >
            {m.label}
          </button>
        ))}
      </nav>
    </header>
  );
}
